import { AreaApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const area = new AreaApi(config);

export default area;
